// extracted by mini-css-extract-plugin
export default {"bodywrapper":"landingpage_bodywrapper__yP3w6"};